import { Router } from "@angular/router";
import { EnumService } from "./../../shared/services/enum.service";
import { Component, OnInit, Input } from "@angular/core";
import {
  SwiperConfigInterface,
  SwiperPaginationInterface,
} from "ngx-swiper-wrapper";
import { environment } from "src/environments/environment";
import { ItemsService } from "src/app/services/items.service";
import { NgxSpinnerService } from "ngx-spinner";
import { EcommService } from "src/app/services/ecomm.service";
import { constApi } from "src/environments/constApi";

@Component({
  selector: "app-main-carousel",
  templateUrl: "./main-carousel.component.html",
  styleUrls: ["./main-carousel.component.sass"],
})
export class MainCarouselComponent implements OnInit {
  // @Input('slides') slides: Array<any> = [];
  esMovil: boolean = false;

  get slides() {
    return this._slides;
  }
  _slides: any;
  paramsCarousel: any;
  paramsCarouselMovil: any;
  public config: SwiperConfigInterface = {};

  private pagination: SwiperPaginationInterface = {
    el: ".swiper-pagination",
    clickable: true,
  };
  // loader: boolean = false;
  dataStorage: any;
  isLoader: boolean = true;
  banners: any[] = [];
  @Input()
  set slides(value: Array<any>) {
    this.banners = value;
    this.paramsCarousel = value.filter((x) => x.AccionBanner != "MovilBanner");
    this.paramsCarouselMovil = value.filter(
      (x) => x.AccionBanner == "MovilBanner"
    );
    let tamaño = window.innerWidth;
    if (tamaño <= 730) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }
  constructor(
    private enumService: EnumService,
    private router: Router,
    private itemService: ItemsService,
    private ecomService: EcommService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {}
  ngDoCheck() {
    if (this.isLoader) {
      this.isLoader = false;
    }
    let tamaño = window.innerWidth;
    this.paramsCarouselMovil = [];
    this.paramsCarousel = [];
    this.paramsCarousel = this.banners.filter(
      (x) => x.AccionBanner != "MovilBanner"
    );
    this.paramsCarouselMovil = this.banners.filter(
      (x) => x.AccionBanner == "MovilBanner"
    );
    if (tamaño <= 730) {
      this.esMovil = true;
    } else {
      this.esMovil = false;
    }
  }

  ngAfterViewInit() {
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      speed: 500,
      effect: "slide",
    };
  }

  cargarCarousel(slides) {
    this.paramsCarousel = slides;
  }

  /*cargarCarousel(slides) {
    //console.log(slides);
    this.enumService.getBannerPRC().subscribe((res: any) => {
      this.paramsCarousel = res;
      this.config = {
        slidesPerView: 1,
        spaceBetween: 0,
        keyboard: true,
        navigation: true,
        pagination: this.pagination,
        grabCursor: true,
        loop: false,
        preloadImages: true,
        lazy: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 500,
        effect: "fade",
      };
    });
  }*/

  async irAProductos(item) {
    console.log(item)
    let paramCodigo = item.Codigo.length == 0 ? "0" : item.Codigo;
    if (item.AccionBanner == "GRUPO") {
      this.router.navigate([
        "/home/products",
        item.Codigo,
        0,
        0,
        item.Marca,
        0,
        0,
        1,
      ]);
    } else {
      if (item.idItemEC == null) {
        if (item.Marca.length == 0) {
          this.router.navigate([
            "/home/products",
            paramCodigo,
            0,
            0,
            "TODAS",
            0,
            0,
            1,
          ]);
        } else {
          this.router.navigate([
            "/home/products",
            paramCodigo,
            0,
            item.Marca,
            0,
            0,
            0,
            1,
          ]);
        }
      } else {
        this.spinner.show()
        await this.itemService.sumarClic(item.idItemEC);
        this.spinner.hide()
        this.router.navigate(["/home/product", item.idItemEC]);
      }
    }
  }
  async buscarItem(param: any) {
    return await this.ecomService
      .getParam(environment.apiUrl,constApi.ITEMSLIST, param)
      .toPromise()
      .catch((error: any) => {
        this.spinner.hide();
      });
  }
  // ngAfterViewInit() {
  //   this.config = {
  //     slidesPerView: 1,
  //     spaceBetween: 0,
  //     keyboard: true,
  //     navigation: true,
  //     pagination: this.pagination,
  //     grabCursor: true,
  //     loop: false,
  //     preloadImages: true,
  //     lazy: false,
  //     autoplay: {
  //       delay: 6000,
  //       disableOnInteraction: false
  //     },
  //     speed: 500,
  //     effect: "slide"
  //   }
  // }
}
